
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.665 7A6.666 6.666 0 11.333 7a6.666 6.666 0 0113.332 0zM7 8.344a1.237 1.237 0 100 2.473 1.237 1.237 0 000-2.473zM5.825 3.899l.2 3.656c.008.171.15.305.321.305h1.305a.323.323 0 00.322-.305l.2-3.656a.323.323 0 00-.322-.34H6.147a.323.323 0 00-.322.34z","fill":"#F18E32"}})])
          )
        }
      }
    